import styled, { css } from 'styled-components';
import { alignSelf, justifySelf } from 'styled-system';

import {
  getInvisibility,
  getVisibility,
} from '@/components/Visibility/Visibility.styles';

import type { ColProps } from './Col';

const getOrder = (
  columns: number,
  order?: number,
  orderFirst?: boolean,
  orderLast?: boolean,
) =>
  (order !== undefined || orderFirst || orderLast) &&
  css`
    order: ${order !== undefined
      ? order
      : orderFirst
        ? -1
        : orderLast
          ? columns + 1
          : 0};
  `;
const generateGridProps = (columns: number, columnStart?: number) => css`
  grid-column: span ${columns};
  grid-column-start: ${columnStart ? columnStart : undefined};
  grid-column-end: ${columnStart ? columnStart + columns : undefined};
`;

export const Wrapper = styled.div<{ xs: number } & ColProps>`
  ${alignSelf};
  ${justifySelf};
  ${({
    handleDisplay,
    handleVisibility,
    lg,
    lgHidden,
    lgOrder,
    lgOrderFirst,
    lgOrderLast,
    lgStart,
    lgVisible,
    md,
    mdHidden,
    mdOrder,
    mdOrderFirst,
    mdOrderLast,
    mdStart,
    mdVisible,
    sm,
    smHidden,
    smOrder,
    smOrderFirst,
    smOrderLast,
    smStart,
    smVisible,
    theme: { mediaQueries },
    theme: {
      gridColumns: {
        lg: lgColumns,
        md: mdColumns,
        sm: smColumns,
        xl: xlColumns,
        xs: xsColumns,
      },
    },
    xl,
    xlHidden,
    xlOrder,
    xlOrderFirst,
    xlOrderLast,
    xlStart,
    xlVisible,
    xs,
    xsHidden,
    xsOrder,
    xsOrderFirst,
    xsOrderLast,
    xsStart,
    xsVisible,
  }) =>
    css`
      margin-bottom: auto;

      ${getVisibility(
        handleDisplay,
        handleVisibility,
        xsHidden || smHidden || mdHidden || lgHidden || xlHidden,
      )};

      ${getInvisibility(
        handleDisplay,
        handleVisibility,
        xsVisible || smVisible || mdVisible || lgVisible || xlVisible,
      )};

      ${xs && generateGridProps(xs, xsStart)};
      ${getVisibility(handleDisplay, handleVisibility, xsVisible)};
      ${getInvisibility(handleDisplay, handleVisibility, xsHidden)};
      ${getOrder(xsColumns, xsOrder, xsOrderFirst, xsOrderLast)};

      ${mediaQueries.sm} {
        ${sm
          ? generateGridProps(sm, smStart || xsStart)
          : smStart
            ? generateGridProps(xs, smStart)
            : ''};
        ${getVisibility(handleDisplay, handleVisibility, smVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, smHidden)};
        ${getOrder(
          smColumns,
          xsOrder ?? smOrder,
          xsOrderFirst ?? smOrderFirst,
          xsOrderLast ?? smOrderLast,
        )};
      }
      ${mediaQueries.md} {
        ${md
          ? generateGridProps(md, mdStart || smStart || xsStart)
          : mdStart
            ? generateGridProps(sm || xs, mdStart)
            : ''};
        ${getVisibility(handleDisplay, handleVisibility, mdVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, mdHidden)};
        ${getOrder(
          mdColumns,
          xsOrder ?? smOrder ?? mdOrder,
          xsOrderFirst ?? smOrderFirst ?? mdOrderFirst,
          xsOrderLast ?? smOrderLast ?? mdOrderLast,
        )};
      }
      ${mediaQueries.lg} {
        ${lg
          ? generateGridProps(lg, lgStart || mdStart || smStart || xsStart)
          : lgStart
            ? generateGridProps(md || sm || xs, lgStart)
            : ''}
        ${getVisibility(handleDisplay, handleVisibility, lgVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, lgHidden)};
        ${getOrder(
          lgColumns,
          xsOrder ?? smOrder ?? mdOrder ?? lgOrder,
          xsOrderFirst ?? smOrderFirst ?? mdOrderFirst ?? lgOrderFirst,
          xsOrderLast ?? smOrderLast ?? mdOrderLast ?? lgOrderLast,
        )};
      }
      ${mediaQueries.xl} {
        ${xl
          ? generateGridProps(
              xl,
              xlStart || lgStart || mdStart || smStart || xsStart,
            )
          : xlStart
            ? generateGridProps(lg || md || sm || xs, xlStart)
            : ''}
        ${getVisibility(handleDisplay, handleVisibility, xlVisible)};
        ${getInvisibility(handleDisplay, handleVisibility, xlHidden)};
        ${getOrder(
          xlColumns,
          xsOrder ?? smOrder ?? mdOrder ?? lgOrder ?? xlOrder,
          xsOrderFirst ??
            smOrderFirst ??
            mdOrderFirst ??
            lgOrderFirst ??
            xlOrderFirst,
          xsOrderLast ??
            smOrderLast ??
            mdOrderLast ??
            lgOrderLast ??
            xlOrderLast,
        )};
      }
    `}
`;
